// StudentLayout.jsx
import React, { useContext } from 'react';
import { 
  AppBar, 
  Toolbar, 
  Typography, 
  Button, 
  Box, 
  Container,
  useTheme,
  useMediaQuery 
} from '@mui/material';
import { Logout, VideoLibrary, Person } from '@mui/icons-material';
import { useNavigate, useLocation } from 'react-router-dom';
import { AuthContext } from '../store/AuthContext';

export default function StudentLayout({ children }) {
  const { logout, user } = useContext(AuthContext);
  const navigate = useNavigate();
  const location = useLocation();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  const getPageTitle = () => {
    const path = location.pathname;
    if (path.includes('select-class')) return 'Select Class';
    if (path.includes('select-subject')) return 'Select Subject';
    if (path.includes('videos')) return 'Learning Videos';
    if (path.includes('watch')) return 'Watch Video';
    return 'Student Portal';
  };

  return (
    <Box sx={{ flexGrow: 1, minHeight: '100vh', background: theme.palette.background.default }}>
      {/* Header */}
      <AppBar 
        position="static" 
        sx={{ 
          background: 'linear-gradient(45deg, #2196F3, #21CBF3)',
          boxShadow: theme.shadows[3]
        }}
      >
        <Toolbar>
          <VideoLibrary sx={{ mr: 2 }} />
          <Typography variant="h6" component="div" sx={{ flexGrow: 1, fontWeight: 'bold' }}>
            {getPageTitle()}
          </Typography>
          
          {/* User Info */}
          {user && (
            <Box sx={{ display: 'flex', alignItems: 'center', mr: 2 }}>
              <Person sx={{ mr: 1, fontSize: 20 }} />
              <Typography variant="body2" sx={{ display: { xs: 'none', sm: 'block' } }}>
                {user.name || user.email}
              </Typography>
            </Box>
          )}
          
          {/* Logout Button */}
          <Button 
            color="inherit" 
            onClick={handleLogout}
            startIcon={<Logout />}
            size={isMobile ? "small" : "medium"}
            sx={{
              border: '1px solid rgba(255,255,255,0.3)',
              '&:hover': {
                backgroundColor: 'rgba(248, 1, 1, 1)',
                transform: 'translateY(-1px)',
              },
              transition: 'all 0.3s ease',
            }}
          >
            {isMobile ? '' : 'Logout'}
          </Button>
        </Toolbar>
      </AppBar>

      {/* Page Content */}
      <Container 
        maxWidth="lg" 
        sx={{ 
          py: 4,
          minHeight: 'calc(100vh - 64px)'
        }}
      >
        {children}
      </Container>
    </Box>
  );
}